var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDriverTipsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Driver Tips") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Driver-Tips",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 0.270000)",
    fill: "#FF7800"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.025,1.35 C1.652211,1.35 1.35,1.652211 1.35,2.025 L1.35,9.45 C1.35,9.8228025 1.652211,10.125 2.025,10.125 L4.3875,10.125 L4.3875,11.475 L2.025,11.475 C0.90662625,11.475 0,10.5684075 0,9.45 L0,2.025 C0,0.90662625 0.90662625,0 2.025,0 L10.125,0 C11.2434075,0 12.15,0.90662625 12.15,2.025 L12.15,9.45 C12.15,10.5684075 11.2434075,11.475 10.125,11.475 L7.7625,11.475 L7.7625,10.125 L10.125,10.125 C10.4978025,10.125 10.8,9.8228025 10.8,9.45 L10.8,2.025 C10.8,1.652211 10.4978025,1.35 10.125,1.35 L2.025,1.35 Z",
    id: "Path",
    stroke: "#FF7800",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FF7800",
    strokeWidth: 0.5,
    fillRule: "nonzero",
    strokeLinejoin: "round",
    points: "6.075 11.8125 4.3875 10.125 4.05 11.475 6.075 13.5 8.1 11.475 7.7625 10.125"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fillRule: "nonzero",
    points: "5.0625 5.0625 6.075 2.3625 7.0875 5.0625 9.45 6.075 7.0875 7.0875 6.075 9.7875 5.0625 7.0875 2.7 6.075"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverTipsIcon);
export default __webpack_public_path__ + "static/media/driver-tips-icon.0bb5ef891bc684498717e9922908e633.svg";
export { ForwardRef as ReactComponent };